import { render, staticRenderFns } from "./newIndex1.vue?vue&type=template&id=083e97b4&scoped=true&"
import script from "./newIndex1.vue?vue&type=script&lang=js&"
export * from "./newIndex1.vue?vue&type=script&lang=js&"
import style0 from "./newIndex1.vue?vue&type=style&index=0&id=083e97b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e97b4",
  null
  
)

export default component.exports